<template>
  <div class="col-md-12">
    <div v-if="!this.submitted" class="card card-container">
      <h5>
        <b>Ανάκτηση Συνθηματικού</b>
      </h5>
      <br />
      <form name="form" @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="username">'Ονομα χρήστη (Username)</label>
          <input
            v-model="username"
            v-validate="'required'"
            type="username"
            class="form-control"
            name="username"
          />
        </div>
        <div class="form-group">
          <label for="mail">E-mail</label>
          <input
            v-model="mail"
            v-validate="'required'"
            type="text"
            class="form-control"
            name="mail"
          />
        </div>

        <div class="form-group">
          <div v-if="showCaptcha">
          <reCAPTCHA ref="googleReCaptcha" v-bind:data-sitekey="this.GOOGLE_RECAPTCHA_SITE_KEY" style="display: inline-block;  margin: auto; width: 50%;"></reCAPTCHA>
          <div id="g-recaptcha-error"></div>
          <br />
          </div>
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>&nbsp;
            <span>Υποβολή</span>
          </button>
        </div>
      </form>
    </div>
    <div v-else>
      <div class="alert alert-success text-center">{{this.message}}</div>
    </div>
  </div>
</template>

<script>
import AuthService from '../services/auth.service';
import toast from '../services/toast';
import ReCAPTCHA from "../components/reCAPTCHA";

export default {
  name: 'restore',
  components: {ReCAPTCHA},
  data() {
    return {
      submitted: false,
      message: null,
      username: null,
      mail: null,
      loading: false
    };
  },

  mounted() {
    this.GOOGLE_RECAPTCHA_SITE_KEY = process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY;
    this.showCaptcha =  process.env.NODE_ENV !== 'development';
  },
  methods: {
    handleSubmit() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          if (!this.username) {
            toast.error("Το πεδίο 'Ονομα χρήστη απαιτείται!");
          }
          if (!this.mail) {
            toast.error('Το πεδίο E-mail απαιτείται!');
          }
          this.loading = false;
          return;
        }

        let reCAPTCHAUserToken = null;
        if (this.showCaptcha) {
          reCAPTCHAUserToken = this.$refs.googleReCaptcha.getUserToken();

          if (reCAPTCHAUserToken.length == 0) {
            this.loading = false;
            document.getElementById('g-recaptcha-error').innerHTML =
                    '' +
                    '<span style="color:red;">Η επίλυση του captcha είναι απαραίτητη.</span>';
            return;
          }
        }

        if (this.username && this.mail) {
          var data = {
            username: this.username,
            mail: this.mail,
            reCAPTCHAUserToken: reCAPTCHAUserToken
          };
          AuthService.restorePwd(data)
            .then(response => {
              this.loading = false;
              this.submitted = true;
              this.message = 'Θα σταλεί email ανάκτησης του συνθηματικού σας!'; 
            })
            .catch(e => {
              if (this.showCaptcha) {
                this.$refs.googleReCaptcha.reset();
              }
              this.loading = false;
              console.log(e);
            });
        }
      });
    },
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  /* padding: 40px 40px; */
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>